export enum NotificationsPreferences {
  MY_TASKS = "my_tasks",
  ALL_TASKS = "all_tasks",
}

export interface projectGroupModel {
  groupId: string;
  groupName: string;
  projectId: string;
  memberId?: string;
}

export interface NotificationSettingsModel {
  myTasks: NotificationsPreferences
  comments: boolean;
  starts: boolean;
  declaredComplete: boolean;
  approved: boolean;
  issues: boolean;
  waiting: boolean;
  resume: boolean;
  blocked: boolean;
  suspended: boolean;
  forecast: boolean;
  checklist: boolean;
  taskForce: boolean;
  critical: boolean;
}

